var agi = agi || {};
agi.expressions = agi.expressions || {};
agi.expressions.JLConfig = (function() {
    return {videoAccount: "1640544087001",
            videoPlayer: "HJsZblZgb"}

})();